import { useMemo } from 'react';
import { DateRange, RangeFilter, RangePreset, resolveRange, todayUTC } from '../components/filters/dateRange';

// The page-level date range of a usage tab. `range` is null while a custom
// range is incomplete, so nothing is fetched until it is valid. Today is read
// on every render, so a refetch after UTC midnight moves a preset to the new day.
export function useUsageRange(preset: RangePreset, from: string, to: string): { rangeFilter: RangeFilter; range: DateRange | null } {
  const rangeFilter = useMemo(() => ({ preset, from, to }), [preset, from, to]);
  const time = todayUTC().getTime();
  const range = useMemo(() => resolveRange(rangeFilter, new Date(time)), [rangeFilter, time]);
  return { rangeFilter, range };
}
